import React from 'react';
import { Typography, Box } from '@mui/material';

function SpouseWorkExperienceInfo() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Spouse's Canadian Work Experience
      </Typography>
      <Typography variant="body1" paragraph>
        If your spouse or common-law partner is accompanying you to Canada, their Canadian work experience can contribute points to your CRS score.
      </Typography>
      <Typography variant="body1" paragraph>
        The work experience must be skilled (TEER 0, 1, 2, or 3) and obtained in Canada within the last 10 years.
      </Typography>
    </Box>
  );
}

export default SpouseWorkExperienceInfo;